import { render } from "./App.vue?vue&type=template&id=4910a200"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=4910a200&lang=less"

import exportComponent from "D:\\codeDevelopment\\文稿通\\wgt_user_web_2.0\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__